module.exports = __webpack_public_path__ + "img/loginbg.ead14300.png";